import {
  ElementDTO,
  ExpositionPolitique,
  Fiscalite,
  FiscaliteVersement,
  PreconisationInformationDTO,
  ProduitDTO,
  ProfilFinancier,
  ProjectionParams,
  ResultatsCalculDTO,
  Simulation,
  TypeModalite,
  TypeParcours,
  TypeProduit
} from "@mra/hlp9002";
import { AffichageInfos } from "../models/affichageInfos";
import { Beneficiaire } from "../models/beneficiaire.model";
import { DebugRequest } from "../models/debugRequest";
import { PreconisationModifiee } from "../models/preconisationModifiee.model";
import { QuestionReponse } from "../models/questionReponse.model";

export interface DebugState {
  modeDebug: boolean;
  requests: DebugRequest<any>[];
}

export interface ErrorsState {
  errors: string[];
}

export interface PrestationState {
  fiscalite: Fiscalite;
  profilFinancier: ProfilFinancier;
  exposition: ExpositionPolitique;
}

export type ChangementQuestion = {
  currentQuestionCode: string;
  currentResponse: string;
  nextQuestionCode: string;
};

export interface QuestionnaireState {
  typeParcours: TypeParcours;
  questionsReponses: QuestionReponse[];
  affichageInfos: AffichageInfos;
}

export enum ParentChampConso {
  REPARTITION = "repartition",
  RPP = "revenuRegulier",
  RETENU_OPTION = "renteRetenuOption"
}
export enum SousChampConso {
  RENTE = "rente",
  RPP = "rpp",
  CAPITAL_PONCTUEL = "capitalPonctuel",
  SELECTION_RETENU_OPTION = "sumSelect",
  REVENU_REGULIER_SUM = "sum",
  REVENU_REGULIER_DURATION = "duration"
}

export type SousChampConsoRPP = SousChampConso.REVENU_REGULIER_DURATION | SousChampConso.REVENU_REGULIER_SUM;

export type EntreeHistoriqueOption = {
  type: TypeModalite;
  value: string;
};

export interface ChangementSimConso {
  champParent: ParentChampConso;
  champEnfant: SousChampConso;
  value: number;
}

export interface RenteState {
  renteSansOpt?: ResultatsCalculDTO;
  renteAvecOpt?: ResultatsCalculDTO;

  preconisation?: PreconisationInformationDTO;
  precoModifiee?: PreconisationModifiee;
  historiqueConso?: ChangementSimConso[];

  selectedOptionsRente?: Map<TypeModalite, string>;
  historiqueOptions?: EntreeHistoriqueOption[];

  beneficiaire?: Beneficiaire;
  clauseBeneficiaireCode?: string;
}

export interface SavedRenteState extends RenteState {
  selectedOptionsRente?: any;
}

export interface PageStructure {
  footer: ElementDTO;
  header: ElementDTO;
  breadcrumbs: ElementDTO;
  typeProduit: TypeProduit;
}

export interface UserState {
  simulation?: Simulation;
  pageStructure?: PageStructure;
  originalSimulation?: Simulation;
  produit?: ProduitDTO;
  typeProduit?: TypeProduit;
  userInited?: boolean;
}

export interface VersementState {
  fiscaliteVersement: FiscaliteVersement;
  versementConfig: ProjectionParams;
  editedIban: string;
}

export type MraState =
  | DebugState
  | ErrorsState
  | PrestationState
  | QuestionnaireState
  | RenteState
  | UserState
  | VersementState;
